<template>
  <div class="add">
    <div class="add-center">
      <!-- 头部 -->
      <header style="display: flex; align-items: center">
        <a-icon type="left-circle" class="btn_back" theme="twoTone" @click="$router.go(-1)" />
        <p>{{ gettypefunname }}</p>
        <!-- <a-icon type="left-circle" style="font-size: 20px; margin-left: 10px" @click="$router.go(-1)" /> -->
      </header>
      <aside>
        <div class="main">
          <div class="main-form">
            <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol" labelAlign="left">
              <h2>核心信息sell</h2>
              <a-button type="primary" class="addInfor" v-if="addBtnShow" @click="addClick">添加联系人信息</a-button>
              <!--业主最少一条 最多三条  代理人最多一条 非必填-->
              <a-row v-for="(item, index) in form.lessorInfoBoList" :key="index">
                <a-col :span="4">
                  <a-form-model-item ref="lessorsName" label="联系人" :required="true">
                    <a-input style="width: 185px" v-model="item.lessorsName" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="联系人电话" :required="true">
                    <a-input
                      @blur="getLessorsPhone"
                      @change="validateLessorsPhone(item.lessorsPhone, index)"
                      style="width: 185px"
                      :max-length="11"
                      v-model="item.lessorsPhone"
                    />
                    <p style="font-size: 12px; color: red">{{ item.phoneTips }}</p>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="业主类型" :required="true">
                    <a-select v-model="item.lessorsType" style="width: 185px" @change="getLessorsType">
                      <a-select-option v-for="lessor in lessorTypeList" :key="lessor.dictValue" :value="lessor.dictValue">
                        {{ lessor.dictLabel }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-button v-if="form.lessorInfoBoList.length > 1" type="link" class="addInfor" @click="delClick(index)">
                    <a-icon type="minus-circle" :style="{ fontSize: '24px', color: 'red' }" />
                  </a-button>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="4">
                  <a-form-model-item label="区域" prop="districtId">
                    <a-select v-model="form.districtId" style="width: 185px" @change="regionChange($event, 'addSaleHouse')">
                      <a-select-option v-for="item in region" :key="item.areaId" :value="item.areaId">{{ item.areaName }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item prop="businessDistrictId" label="商圈">
                    <a-select
                      show-search
                      v-model="form.businessDistrictId"
                      style="width: 175px"
                      :default-active-first-option="false"
                      :show-arrow="true"
                      :filter-option="false"
                      :not-found-content="null"
                      @keyup.enter.native="onEnterPress()"
                      @search="businessDisSearch"
                      @change="businessDistrictMethod($event, 'addSaleHouse')"
                    >
                      <a-select-option v-for="item in businessDistrict" :key="item.id" :value="item.id">
                        {{ item.businessDistrictName }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item prop="streetId" label="街道">
                    <a-select
                      show-search
                      v-model.trim="form.streetId"
                      style="width: 175px"
                      :default-active-first-option="false"
                      :show-arrow="true"
                      :filter-option="false"
                      :not-found-content="null"
                      @keyup.enter.native="onEnterStreet()"
                      @search="streetSearch"
                      @change="StreetMethod($event, 'addSaleHouse')"
                    >
                      <a-select-option v-for="item in StreetData" :key="item.id" :value="item.id">{{ item.streetFullName }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="8">
                  <div style="display: flex">
                    <a-form-model-item ref="houseNumber" label="门牌号" prop="houseNumber">
                      <a-select v-model="form.houseNumber" placeholder="门牌号" style="width: 80px" @change="houseNumberMethod">
                        <a-select-option v-for="(item, index) in doorNumData" :key="index" :value="item.houseNumber">
                          {{ item.houseNumber }}
                        </a-select-option>
                      </a-select>
                      <!-- <a-input
                      style="width: 65px"
                      @change="getSearchHouseMsg"
                      v-model="form.houseNumber"
                      @blur="
                        () => {
                          $refs.houseNumber.onFieldBlur()
                        }
                      "
                    /> -->
                      <span style="margin-left: 10px; margin-right: 10px"><!-- 号附 --></span>
                    </a-form-model-item>
                    <a-form-model-item ref="houseNumberDeputy" label="附号" prop="houseNumberDeputy">
                      <a-select v-model="form.houseNumberDeputy" placeholder="附号" style="width: 160px" @change="houseNumberDeputyChange">
                        <a-select-option v-for="item in attachedNumberData" :key="item.id" :value="item.attachedNumber">
                          {{ item.attachedNumber }}
                        </a-select-option>
                      </a-select>
                      <a-button @click="getSearchHouseMsg" class="search-btn">查询</a-button>
                    </a-form-model-item>
                  </div>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="4">
                  <a-form-model-item style="width: 185px" label="小区名称" prop="communityName" :required="false">
                    <a-input v-model="form.communityName"></a-input>
                    <a-input v-model="form.communityName" v-show="1 === 2"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="楼层" prop="houseFloorType">
                    <!-- 1单层2多层3独栋 -->
                    <a-select v-model="form.houseFloorType" placeholder="" style="width: 80px">
                      <a-select-option v-for="item in floorTypeOpts" :key="item.dictValue" :value="item.dictValue">
                        {{ item.dictLabel }}
                      </a-select-option>
                    </a-select>
                    <span v-if="form.houseFloorType !== '3'">
                      第
                      <a-input v-model="form.houseFloor" style="width: 80px"></a-input>
                      层
                    </span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="floorTotal" prop="floorTotal" label="整栋层数">
                    <a-input
                      :max-length="3"
                      style="width: 185px"
                      v-model="form.floorTotal"
                      @blur="
                        () => {
                          $refs.floorTotal.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <div class="hr"></div>
              <p>基本信息</p>
              <a-row>
                <a-col :span="4">
                  <a-form-model-item ref="shopName" label="店铺标题" prop="shopName">
                    <a-input
                      :max-length="15"
                      style="width: 185px"
                      v-model="form.shopName"
                      @blur="
                        () => {
                          $refs.shopName.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item prop="shopTypeId" label="商铺类型">
                    <a-select v-model="form.shopTypeId" placeholder="请选择" style="width: 185px">
                      <a-select-option v-for="item in shopType" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item label="商铺性质" prop="shopNatureId">
                    <a-select @change="shopNatureChange" v-model="form.shopNatureId" placeholder="二手商铺" style="width: 185px">
                      <a-select-option v-for="item in shopNature" :key="item.dictValue" :value="item.dictValue">{{ item.dictLabel }}</a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item prop="operatingStatusId" label="经营状态">
                    <a-select
                      :disabled="form.shopNatureId === '3'"
                      v-model="form.operatingStatusId"
                      placeholder="请选择经营状态"
                      style="width: 185px"
                    >
                      <a-select-option v-for="item in operatStatus" :key="item.dictValue" :value="item.dictValue">
                        {{ item.dictLabel }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row>
                <a-col :span="20">
                  <a-form-model-item label="可经营行业">
                    <div style="display: flex; justify-content: space-between; align-items: flex-start">
                      <a-select
                        mode="multiple"
                        v-model="form.industryCategoryJsonId"
                        :filter-option="filterOption"
                        @change="industryCategoryChange"
                        placeholder="行业大类"
                        style="margin-right: 5px"
                      >
                        <a-select-option v-for="item in industryClass" :key="item.id" :value="item.id.toString()">
                          {{ item.industryCategoryName }}
                        </a-select-option>
                      </a-select>
                      <a-select
                        mode="multiple"
                        v-model="form.industrySubclassJsonId"
                        :filter-option="filterOption"
                        @change="industrySubCategoryChange"
                        placeholder="行业小类"
                      >
                        <a-select-option v-for="item in showIndustrySubclass" :key="item.id" :value="item.id.toString()">
                          {{ item.industryCategoryName }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row v-if="form.operatingStatusId === '2'">
                <a-col :span="4">
                  <a-form-model-item ref="rentFee" label="租金" prop="rentFee">
                    <a-input :max-length="8" suffix="元" v-model="form.rentFee" style="width: 185px" @blur="rent"></a-input>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="expireTime" label="到期时间" prop="expireTime">
                    <a-date-picker v-model="form.expireTime" show-time type="date" style="width: 185px" @blur="rent" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item class="inline-box" ref="paymentMethod2" label="付款方式" prop="paymentMethod2">
                    押&nbsp;
                    <a-input :max-length="6" suffix="月" v-model="paymentMethod1" style="width: 80px"></a-input>
                    付&nbsp;
                    <a-input :max-length="6" suffix="月" style="width: 80px" v-model="paymentMethod2"></a-input>
                  </a-form-model-item>
                </a-col>
                <!-- 项目经理说不要按照原型图来  不要钥匙了 -->
              </a-row>
              <a-row>
                <a-col :span="4">
                  <a-form-model-item label="是否可餐饮" prop="isCatering">
                    <div style="display: flex">
                      <a-select v-model="form.isCatering" @change="getState" placeholder="请选择" style="width: 80px">
                        <a-select-option v-for="item in weatherOpts" :key="item.dictValue" :value="item.dictValue">
                          {{ item.dictLabel }}
                        </a-select-option>
                      </a-select>

                      <a-select v-if="form.isCatering === 'Y'" v-model="form.alloweCateringTypeId" placeholder="请选择" style="width: 110px">
                        <a-select-option v-for="item in repastTypeOpts" :key="item.dictValue" :value="item.dictValue">
                          {{ item.dictLabel }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="pooledAreaRatio" label="公摊" prop="pooledAreaRatio">
                    <a-input style="width: 185px" :max-length="6" v-model="form.pooledAreaRatio" suffix="%" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="grossFloorArea" label="建筑面积" prop="grossFloorArea">
                    <a-input
                      :max-length="8"
                      v-model="form.grossFloorArea"
                      style="width: 185px"
                      suffix="m"
                      @change="getUnitPrice"
                      @blur="
                        () => {
                          $refs.grossFloorArea.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="saleableArea" label="实用面积" prop="saleableArea">
                    <a-input
                      style="width: 185px"
                      v-model="form.saleableArea"
                      suffix="m"
                      @blur="
                        () => {
                          $refs.saleableArea.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>

              <div class="hr"></div>
              <p>价格信息</p>
              <a-row>
                <a-col :span="4">
                  <a-form-model-item label="售价" prop="salePrice">
                    <a-input :max-length="10" style="width: 185px" v-model="form.salePrice" @change="getUnitPrice" suffix="万元" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="unitPrice" label="单价(万元/m²)" prop="unitPrice">
                    <a-input
                      style="width: 185px"
                      v-model="form.unitPrice"
                      disabled
                      @blur="
                        () => {
                          $refs.unitPrice.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="houseOwnership" label="权属" prop="houseOwnership">
                    <a-input
                      v-model="form.houseOwnership"
                      style="width: 185px"
                      @blur="
                        () => {
                          $refs.houseOwnership.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="4">
                  <a-form-model-item ref="houseYears" prop="houseYears" label="房本年限(年)">
                    <a-input
                      :max-length="6"
                      style="width: 178px"
                      v-model="form.houseYears"
                      @blur="
                        () => {
                          $refs.houseYears.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item>
                    <!-- @change="onChange" -->
                    <div slot="label">
                      不动产发票金额
                      <a-checkbox @change="invoiceChange"></a-checkbox>
                    </div>
                    <a-input :max-length="25" :disabled="invoiceChecked" v-model="form.realEstateInvoiceAmount" suffix="万元" style="width: 185px" />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item>
                    <div slot="label">
                      抵押(金额)
                      <a-checkbox @change="mortgageChange"></a-checkbox>
                    </div>
                    <a-input :max-length="25" :disabled="mortgageChecked" v-model="form.pawnAmount" suffix="万元" style="width: 185px" />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="4">
                  <a-form-model-item ref="propertyFee" label="商业物业费" prop="propertyFee">
                    <a-input
                      :max-length="8"
                      style="width: 185px"
                      v-model="form.propertyFee"
                      suffix="元"
                      @blur="
                        () => {
                          $refs.propertyFee.onFieldBlur();
                        }
                      "
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="electricityFee" label="商业电费" prop="electricityFee">
                    <a-input
                      @blur="
                        () => {
                          $refs.electricityFee.onFieldBlur();
                        }
                      "
                      :max-length="8"
                      style="width: 185px"
                      v-model="form.electricityFee"
                      suffix="元/度"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="waterFee" label="商业水费" prop="waterFee">
                    <a-input
                      @blur="
                        () => {
                          $refs.waterFee.onFieldBlur();
                        }
                      "
                      :max-length="8"
                      style="width: 185px"
                      v-model="form.waterFee"
                      suffix="元/吨"
                    />
                  </a-form-model-item>
                </a-col>
                <a-col :span="4">
                  <a-form-model-item ref="gasFee" label="商业气费" prop="gasFee">
                    <a-input
                      @blur="
                        () => {
                          $refs.gasFee.onFieldBlur();
                        }
                      "
                      :max-length="8"
                      style="width: 185px"
                      v-model="form.gasFee"
                      suffix="元/m³"
                    />
                  </a-form-model-item>
                </a-col>
              </a-row>
              <div class="hr"></div>
              <a-row class="checkrow">
                <a-col :span="24">
                  <a-form-model-item prop="shopAncillaryArr" label="商铺配套">
                    <ul style="margin-left: 0; padding-left: 0px">
                      <li style="margin-bottom: 20px; margin-top: 10px">
                        <a-checkbox-group v-model="form.shopAncillaryArr" @change="shopAncillaryChange">
                          <a-checkbox v-for="item in shopAncillaryOpts" :key="item.dictValue" :value="item.dictLabel">
                            {{ item.dictLabel }}
                            <!-- <span v-if="item.dictLabel == '天然气'">
                              <label for="">气量</label>
                              <input class="input_val" type="number" v-model="form.gasCapacity" suffix="m³" />
                            </span>
                            <span v-if="item.dictLabel == '动力电'">
                              <label for="">电功率</label>
                              <input class="input_val" type="number" v-model="form.electricPower" suffix="kw" />
                            </span> -->
                          </a-checkbox>
                        </a-checkbox-group>
                      </li>
                    </ul>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row class="checkrow">
                <a-col :span="24">
                  <a-form-model-item label="消费配套">
                    <a-checkbox-group @change="consumeAncillaryChange" v-model="form.consumeAncillaryIdArr">
                      <a-checkbox v-for="item in consumeAncillaryOpts" :key="item.dictValue" :value="item.dictValue">
                        {{ item.dictLabel }}
                      </a-checkbox>
                    </a-checkbox-group>
                  </a-form-model-item>
                </a-col>
              </a-row>

              <a-row class="checkrow">
                <a-col :span="24">
                  <a-form-model-item label="自定义标签">
                    <a-checkbox-group v-model="form.tagsIdArr" @change="tagChange">
                      <a-checkbox v-for="item in CusListData" :key="item.id" :value="item.id">
                        {{ item.tagName }}
                      </a-checkbox>
                    </a-checkbox-group>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <div class="hr"></div>
              <p>房源优势</p>
              <a-textarea
                :maxLength="500"
                v-model="form.houseDescription"
                placeholder="房源优势信息（包括周边楼盘、停车、消费人群介绍、周边品牌、推荐行业等信息）"
                :autoSize="true"
                style="width: 100%; height: 200px; border-radius: 10px"
              />
              <p>备注</p>
              <a-textarea
                :maxLength="500"
                v-model="form.otherInfo"
                placeholder="请输入备注信息"
                :autoSize="true"
                style="width: 100%; height: 200px; border-radius: 10px"
              />
              <div class="submit-btns" style="text-align: center">
                <a-form-model-item>
                  <a-button type="primary" class="submit" :disabled="isExists" @click="onSubmit">提交</a-button>
                </a-form-model-item>
              </div>
            </a-form-model>
          </div>
        </div>
      </aside>
      <!-- <a-modal :visible="visibleDetials" :maskClosable="false"  @cancel="visibleDetials=false" title="录入的门牌号已存在房源，请点击确定查看" @ok="handleDetails">
          <p>房源编号：</p>
          <p>{{houseCode}}</p>
        </a-modal> -->
      <a-modal v-model="isBanbetsu" title="新增房源可以选择入盘类别" @ok="handleOkBanbetsu">
        <a-radio-group v-model="form.dishType">
          <a-radio :value="it.dictValue" v-for="it of categoryList" :key="it.dictValue">
            {{ it.dictLabel }}
          </a-radio>
        </a-radio-group>
      </a-modal>
      <a-modal v-model="visibleDetials" title="温馨提示" on-ok="handleOk" :footer="null">
        <p class="">
          录入的门牌号已存在房源：
          <a @click="handleDetails()">{{ houseCode }}</a>
          ,请前往查看!!!
        </p>
      </a-modal>
      <div style="height: 50px"></div>
    </div>
  </div>
</template>

<script>
import houseApi from '@/api/system/houses/house.js';
import { addHouseInfoSale, editHouseInfoSale, houseInfoSale, searchHouseInfoSale } from '@/api/system/houses/houseSale';
import { industryCategoryList } from '@/api/system/industry';
import { singleSelectMixin } from '@/mixin/singleSelect';
import { mapMutations, mapState } from 'vuex';

import beforeRouteLeaveMixin from '@/mixin/beforeRouteLeave';

export default {
  name: 'HousesSellAdd',
  components: {},
  mixins: [singleSelectMixin, beforeRouteLeaveMixin],
  data() {
    return {
      rentSaleType: '2', // 售房
      invoiceChecked: true,
      mortgageChecked: true,
      lessorsPhoneArr: [],
      houseCode: undefined,
      visibleDetials: false,
      detailsId: undefined,
      typeArr: [],
      transferorArr: [],
      twoRoomArr: [],
      agentArr: [],
      isBanbetsu: false, // 入盆类别选择弹窗
      lessorTypeList: [], // 业主类型
      isExists: false, // 提交按钮是否置灰
      gettypefunname: '房源/新增售房',
      addoredit: 0, // 0是新增 1是编辑
      labelCol: { span: 24, offset: 0 },
      wrapperCol: { span: 24 },
      value: 1,
      other: '',
      dataInfo: {},
      categoryList: [], // 入盘类别
      community: {}, // 小区信息
      form: {
        channelResource: '1',
        dishType: '', // 选择入盘类别
        rentSaleType: '2',
        industryCategoryJsonKeyValueId: {},
        pawnAmount: undefined, // 抵押金额
        realEstateInvoiceAmount: undefined, // 不动产发票金额
        houseYears: undefined, // 房本年限
        houseOwnership: undefined, // 权属
        unitPrice: undefined, // 单价
        salePrice: undefined, // 售价
        expireTime: undefined, // 到期时间
        rentFee: undefined, // 租金
        lessorsType: undefined, // 业主类型
        gasFee: undefined, //	气费
        communityName: undefined, //	小区全称
        communityId: undefined, //	小区id
        areaId: undefined, //	行政区ID
        alloweCateringTypeId: undefined, //	允许的餐饮类型ID 字典表类型：repast_type		false
        businessDistrictId: undefined, //	商圈id		true
        businessDistrictName: undefined, //	商圈名称		true
        districtId: undefined, //	区域id		true
        districtName: undefined, //	区域名称		true
        electricPower: undefined, //	电功率		false
        electricityFee: undefined, //	商业电费（元/度）		false
        floorTotal: undefined, //	总楼层		true
        gasCapacity: undefined, //	天然气容量		false
        grossFloorArea: undefined, //	建筑面积		true
        houseBrokerage: undefined, //	房佣		true
        houseFloor: undefined, //	楼层 字典表类型：floor_num		true
        houseHigh: undefined, //	层高		true
        houseLong: undefined, //	进深		true
        houseNumber: undefined, //	门牌号		true
        houseNumberId: undefined, //	门牌号id	true(实际无，门牌号与附号在同一条记录，门牌号未单独列出)
        houseNumberDeputy: undefined, //	门牌附号		false
        houseNumberDeputyId: undefined, //	门牌附号id
        houseWide: undefined, //	开间（面宽）		true
        id: undefined, //	id，新增时不传，修改时必传		true
        industryCategoryId: undefined, //	行业分类 字典表类型：industry_category		true
        industrySubclassId: undefined, //	经营行业 字典表类型：industry_subclass		true
        industryCategoryJsonName: [], // 行业大类名称
        industryCategoryJsonId: [], // 行业大类ID
        industrySubclassJsonName: [], // 行业小类名称
        industrySubclassJsonId: [], // 行业小类ID
        isCatering: undefined, //	是否可餐饮		true
        isEjectSmoke: undefined, //	是否有排烟		true
        isElevator: undefined, //	是否有电梯		true
        isFrontage: 'Y', //	是否临街 字典表类型：sys_yes_no		true
        isGas: undefined, //	是否有天然气		true
        isOfficePass: undefined, //	是否是办公人群		true
        isOtherPass: undefined, //	是否是其它人群		true
        isOutsideArea: undefined, //	是否有外摆区		true
        isParkingSpace: undefined, //	是否有停车位		true
        isPower: undefined, //	是否有动力电		true
        isResidentsPass: undefined, //	是否是居民人群		true
        isSewerSystem: undefined, //	是否有下水		true
        isStudentsPass: undefined, //	是否是学生人群		true
        isTouristPass: undefined, //	是否是旅游人群		true
        isTwowayStairs: undefined, //	是否有双步梯		true
        isWaterworks: undefined, //	是否有上水		true
        lessorInfoBoList: [
          {
            //	业主信息		true
            id: undefined, //	id，新增时不传，修改时必传		true
            lessorsName: undefined, //	业主姓名		true
            lessorsPhone: undefined, //	业主电话
            lessorsType: '', //	业主类型
            phoneTips: '', // 电话输入错误提示
            rentSaleType: '2' // 售房
          }
        ],
        operatingStatusId: undefined, //	经营状态 字典表类型：operating_status		true
        otherInfo: undefined, //	其它信息		false
        houseDescription: undefined, // 商铺介绍
        paymentMethod: undefined, //	支付方式;以YxFx，方式表示，如Y2F3 - 代表押2付3		true
        progressiveIncrease: undefined, //	递增		false
        propertyFee: undefined, //	商业物业费（元）		false
        propertyNatureId: undefined, //	产权性质ID 字典表类型：property_nature		true
        rentFeeCentiare: 0, //
        rentfreePeriod: undefined, //	免租期（天）		true
        saleableArea: undefined, //	实用面积		true
        shopName: undefined, //	店铺标题		true
        shopNatureId: undefined, //	商铺性质 字典表类型：shop_nature		true
        shopTypeId: undefined, //	商铺类型 字典表类型：shop_type		true
        streetId: undefined, //	街道id		true
        streetName: undefined, //	街道名称		true
        tagsContentArray: undefined, //	自定义标签内容数组;标签内容以逗号分隔		false
        tagsIdArray: undefined, //	自定义标签id数组;标签id以逗号分隔		false
        transferFee: undefined, //	转让费（万元）		true
        waterFee: undefined, //	商业水费（吨）
        shopAncillary: '', //	商铺配套名称，多个之间用逗号隔开 字典表类型：shop_ancillary
        shopAncillaryIds: [], // 商铺配套 id集
        trafficCrowd: '', //	客流人群名称，多个之间用逗号隔开 字典表类型：traffic_crowd
        shopAncillaryArr: [],
        tagsIdArr: [],
        tagsContentArr: [],
        pooledAreaRatio: undefined, // 公摊面积占比
        consumeAncillaryArr: [],
        consumeAncillaryIds: [], // 消费配套IDs
        consumeAncillaryIdArr: [], // 消费配套IDs （数组 ，显示）
        consumeAncillary: undefined, // 消费配套，多个之间用逗号隔开
        houseFloorType: undefined // 楼层
      },
      newform: {
        isGas: false,
        isOutsideArea: false,
        isPower: false,
        isEjectSmoke: false,
        isSewerSystem: false,
        isWaterworks: false,
        isElevator: false,
        isParkingSpace: false,
        isTwowayStairs: false,
        isOfficePass: false,
        isStudentsPass: false,
        isResidentsPass: false,
        isTouristPass: false,
        isOtherPass: false
      },

      // 楼层数
      floorData: [],
      // 楼层类型
      floorTypeOpts: [],
      // 商铺类型
      shopType: [],
      // 商铺性质
      shopNature: [],
      // 经营状态
      operatStatus: [],
      // 行业分类
      industryCategory: [],
      // 经营行业（行业子类）
      industrySubclass: [],

      industryClass: [], // 所有经营大类/显示的大类
      showIndustrySubclass: [], // 显示的经营小类

      canIndustryCategoryList: [], // 可经营大类
      canSubIndustryCategoryList: [], // 可经营小类

      // 餐饮类型
      repastType: [],
      // 产权性质
      propertyNature: [],
      weatherOpts: [], // 是否
      shopAncillaryOpts: [], // 商铺配套名称
      trafficCrowdOpts: [], // 客流人群
      repastTypeOpts: [], // 允许的餐饮类型
      consumeAncillaryOpts: [], // 消费配套

      shopAncillary: [],

      food1: '',
      paymentMethod1: 1,
      paymentMethod2: 1,
      // 查询房源信息是否存在弹出框的展示值
      overShow: false,
      food: [
        { id: 0, title: '可轻餐' },
        { id: 1, title: '可重餐' }
      ],
      // 区域
      region: [],
      // // 商圈
      businessDistrict: [],

      // 街道
      StreetData: [],
      // 门牌号
      doorNumData: [],
      // 附号
      attachedNumberData: [],
      // 可餐饮状态
      isCateringStatus: 'false',
      rules: {
        // houseYears: [{ required: true, message: '请输入房本年限', trigger: 'blur' }],
        houseOwnership: [{ required: true, message: '请输入权属', trigger: 'blur' }],
        unitPrice: [{ required: true, message: '请输入单价', trigger: 'blur' }],
        salePrice: [
          { required: true, message: '请输入售价', trigger: 'blur' },
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ],
        expireTime: [{ required: true, message: '请选择到期时间', trigger: 'change' }],
        houseFloorType: [{ required: true, message: '请选择楼层类型', trigger: 'blur' }],
        // shopName: [{ required: true, message: '请输入店铺标题', trigger: 'blur' }],
        // lessorsName: [
        //   { required: true, message: '请输入姓名', trigger: 'blur' },
        //   { min: 2, max: 4, message: '姓名不正确', trigger: 'blur' }
        // ],
        districtId: [{ required: true, message: '请选择区域', trigger: 'change' }],
        businessDistrictId: [{ required: true, message: '请选择商圈', trigger: 'change' }],
        streetId: [{ required: true, message: '请选择街道', trigger: 'change' }],
        shopTypeId: [{ required: true, message: '请选择商铺类型', trigger: 'change' }],
        // shopNatureId: [{ required: true, message: '请选择商铺性质', trigger: 'change' }],
        operatingStatusId: [{ required: true, message: '请选择经营状态', trigger: 'change' }],
        industryCategoryId: [{ required: true, message: '请选择经营分类', trigger: 'change' }],
        propertyNatureId: [{ required: true, message: '请选择产权性质', trigger: 'change' }],
        isFrontage: [{ required: true, message: '请选择是否临街', trigger: 'change' }],
        isCatering: [{ required: true, message: '请选择是否可餐饮', trigger: 'change' }],
        pooledAreaRatio: [
          {
            required: false,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          {
            validator: (rule, val, callback) => {
              if (parseFloat(val) > 100) {
                callback(new Error('比例不可超过100%'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ],
        shopAncillaryArr: [
          {
            type: 'array',
            required: true,
            message: '请选择商铺配套',
            trigger: 'change'
          }
        ],
        rentFee: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { required: true, message: '请输入租金', trigger: 'blur' },
          { min: 1, message: '租金不得小于零', trigger: 'blur' }
        ],
        saleableArea: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { required: true, message: '请输入实用面积', trigger: 'blur' }
        ],
        lessorsPhone: [
          { pattern: /^1[3-9][0-9]{9}$/, message: '格式错误', trigger: 'blur' },
          { required: true, message: '请输入电话号码', trigger: 'blur' }
          // { min: 11, max: 11, message: '请输入正确的电话号码', trigger: 'blur' },
        ],
        houseNumber: [{ required: true, message: '请选择门牌号', trigger: 'blur' }],
        houseNumberDeputy: [{ required: true, message: '请选择附号', trigger: 'blur' }],
        // communityName: [{ required: true, message: '请输入小区名称', trigger: 'blur' }],
        grossFloorArea: [
          { required: true, message: '请输入建筑面积', trigger: 'blur' },
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { message: '建筑面积不得小于零', trigger: 'blur' }
        ],
        houseWide: [
          { required: true, message: '请输入开间', trigger: 'blur' },
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { min: 1, message: '开间数不得小于零125', trigger: 'blur' }
        ],
        houseHigh: [
          { required: true, message: '请输入层高', trigger: 'blur' },
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { min: 1, message: '层高不得小于零', trigger: 'blur' }
        ],
        floorTotal: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
          // { required: true, message: '请输入整栋层数', trigger: 'blur' }
          // { min: 1, message: '层数不得低于0', trigger: 'blur' },
        ],
        houseLong: [
          { required: true, message: '请输入进深', trigger: 'blur' },
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { min: 1, message: '进深不得小于零', trigger: 'blur' }
        ],

        // rentfreePeriod: [
        //   { pattern: /^(([0-9]+)|([1-9][0-9]*))$/, message: '格式错误', trigger: 'blur' }
        //   // { required: true, message: '请输入免租期', trigger: 'blur' }
        //   // { min: 1, message: '免租期不得小于零', trigger: 'blur' },
        // ],
        transferFee: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { required: true, message: '请输入转让费', trigger: 'blur' },
          { min: 1, message: '转让费不得小于零', trigger: 'blur' }
        ],
        paymentMethod: [
          { required: true, message: '请输入转让月数', trigger: 'blur' },
          { min: 1, message: '转让月数不得小于零', trigger: 'blur' }
        ],
        houseBrokerage: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { required: true, message: '请输入房佣金', trigger: 'blur' }
        ],
        propertyFee: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
          // { required: true, message: '请输入商业物业费', trigger: 'blur' }
        ],
        electricityFee: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
          // { required: true, message: '请输入商业电费', trigger: 'blur' }
        ],
        waterFee: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
          // { required: true, message: '请输入商业水费', trigger: 'blur' }
        ],
        gasFee: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
          // { required: true, message: '请输入商业气费', trigger: 'blur' }
        ]
      },
      oneShow: false,
      twoShow: false,
      addBtnShow: true,
      isWatch: false,
      a: 0,
      // 自定义标签
      CusListData: [],
      // 新增自定义标签
      addCusData: {},
      houseId: ''
    };
  },
  created() {
    // this.init()
  },
  deactivated() {
    sessionStorage.removeItem('history');
  },
  activated() {
    const storage = sessionStorage.getItem('history');
    // console.log(storage,'storage')
    let data = {};
    if (storage) {
      data = JSON.parse(storage);
      if (data.fromPage === 'add') {
        //  this.updateStatus = true
        this.resetForm();
        Object.keys(this.form).forEach((el) => {
          if (Array.isArray(this.form[el])) {
            if (el == 'lessorInfoBoList') {
              this.lessorInfoBoList = [
                {
                  lessorsName: undefined, //	业主姓名		true
                  lessorsPhone: undefined, //	业主电话
                  lessorsType: undefined, //	业主类型
                  rentSaleType: '2' // 售房
                }
              ];
            } else {
              this.form[el] = [];
            }
          } else {
            this.form[el] = null;
          }
        });
        // this.updateStatus = false
      }
    }
    this.init();
  },

  computed: {
    ...mapState('tagsView', ['cachedViews'])
  },
  methods: {
    ...mapMutations('tagsView', ['DEL_CACHED_VIEW']),
    init() {
      this.isWatch = false;
      // 区域列表
      this.getDistrict('addSaleHouse', 'init');
      // 行业分类
      this.getIndustryCategory(1);
      this.getDicts('sys_yes_no').then((response) => {
        this.weatherOpts = response.data;
      });
      // 盘别
      this.getDicts('dish_type').then((response) => {
        console.log(response.data, '入盘类别');
        this.categoryList = response.data;
      });
      this.getDicts('shop_ancillary').then((response) => {
        this.shopAncillaryOpts = response.data;
      });

      this.getDicts('traffic_crowd').then((response) => {
        this.trafficCrowdOpts = response.data;
      });

      // 消费配套
      this.getDicts('consume_ancillary').then((response) => {
        this.consumeAncillaryOpts = response.data;
      });

      this.getDicts('repast_type').then((response) => {
        this.repastTypeOpts = response.data;
        this.repastTypeOpts.forEach((item) => {
          if (item.dictLabel === '拒餐饮') {
            // a删除拒餐饮
            this.repastTypeOpts.splice(item.dictSort - 1, 1);
          }
        });
      });

      this.houseId = this.$route.query.id;
      if (this.$route.query.tpfunname && this.houseId) {
        // 编辑跳转的
        this.gettypefunname = this.$route.query.tpfunname;
        this.addoredit = 1;
        this.getHouseDetails();

        // 通过房源id调用接口获取房源详情  渲染到界面上
      } else {
        this.addoredit = 0;
        this.initIndustryCategory();
      }

      // this.getDistrict()
      this.getCusTag();
      // 楼层数
      this.getDicts('floor_num').then((res) => {
        if (res.code === 200) {
          this.floorData = res.data;
        }
      });
      // 楼层类型
      this.getDicts('floor_type').then((res) => {
        if (res.code === 200) {
          this.floorTypeOpts = res.data;
        }
      });
      // 商铺类型
      this.getDicts('shop_type').then((res) => {
        if (res.code === 200) {
          this.shopType = res.data;
        }
      });
      // 商铺性质
      this.getDicts('shop_nature').then((res) => {
        if (res.code === 200) {
          this.shopNature = res.data;
        }
      });
      // 经营状态
      this.getDicts('operating_status').then((res) => {
        if (res.code === 200) {
          this.operatStatus = res.data;
        }
      });

      // 餐饮类型
      this.getDicts('industry_subclass').then((res) => {
        if (res.code === 200) {
          this.repastType = res.data;
        }
      });
      // 产权性质
      this.getDicts('property_nature').then((res) => {
        if (res.code === 200) {
          this.propertyNature = res.data;
        }
      });
      // 获取业主类型字典
      this.getDicts('lessor_type').then((res) => {
        if (res.code === 200) {
          const lessorTypeList = [];
          // this.lessorTypeList = res.data
          res.data.forEach((item, index) => {
            if (item.dictLabel === '业主' || item.dictLabel === '代理人') {
              lessorTypeList.push(item);
            }
          });
          this.lessorTypeList = lessorTypeList;
        }
      });
    },
    // 初始化经营行业（大类）
    initIndustryCategory() {
      const classIds = this.form.industryCategoryJsonId;
      this.getCanIndustryCategoryList('', 1, null); // 所有大类
      this.getCanIndustryCategoryList('', 2, () => {
        if (classIds && classIds.length > 0) {
          // 获取满足条件的子类数据
          this.getShowSubClass(classIds);
        }
      }); // 所有小类
    },
    // 获取经营行业(type 1大类 2小类)
    getCanIndustryCategoryList(parentId, type, func) {
      this.loading = true;
      const parmars = {
        parentId,
        industryCategoryType: type
      };
      industryCategoryList(parmars).then((res) => {
        const { code, data } = res;
        this.loading = false;
        if (code === 200) {
          if (type === 1) {
            this.industryClass = data;
          } else {
            this.industrySubclass = data;
          }
        }

        if (func) {
          func();
        }
      });
    },
    // 确定选择入盘类别
    handleOkBanbetsu() {
      if (!this.form.dishType) {
        this.$message.warning('请选择入盘类别');
        return false;
      }
      // 新增
      this.addhouse();
    },
    getShowSubClass(classIds) {
      // 所有小类
      const allSubClassList = this.industrySubclass;
      // 选择的大类(多选为数组，单选为int)
      const idArr = classIds;
      // 根据选择的小类过滤出显示的小类数据
      //  多选
      var list_ = [];
      if (idArr && idArr.length) {
        list_ = allSubClassList.filter((item) => {
          if (idArr.includes(item.parentId.toString()) || idArr === item.parentId) {
            return item;
          }
        });
      }
      this.showIndustrySubclass = list_;
      //  const newSelSubIds = []
      //  const newSelSubNames = []
      // 选择的子类
      const selSubIds = this.form.industrySubclassJsonId;
      //  for (const showsub of this.showIndustrySubclass) {
      //     if (selSubIds.indexOf(showsub.id.toString()) > -1) {
      //      newSelSubIds.push(showsub.id.toString())
      //      newSelSubNames.push(showsub.industrySubclassJsonName)
      //     }
      //  }
      //   this.form.industrySubclassJsonId = newSelSubIds // 经营行业（行业小类）ID
      //   this.industrySubCategoryChange(newSelSubIds)
      // 子类默认全部选择
      const ids = [];
      // 循环当前选中父类下的所有子类
      const datas = this.showIndustrySubclass.filter((item) => selSubIds.includes(item.id.toString()));
      for (const showsub of this.showIndustrySubclass) {
        // 判断具备跟选择子类相同的父类id
        // 通过所有的子类数据 根据当前数据selSubIds选择了的子类 判断所有子类数据是否存在跟当前选择的数据具备相同的父类
        if (datas && datas.length) {
          if (datas[0].parentId.toString() !== showsub.parentId.toString()) {
            // 把选择了的数据的相同父类下的数据都干掉使用选择了的子类数据
            ids.push(showsub.id.toString());
          }
        } else {
          ids.push(showsub.id.toString());
        }
      }
      // 父类匹配子类解决父类删除子类数据不删除问题
      const list = [...this.form.industrySubclassJsonId, ...ids];
      // 通过子类id匹配出子类数据
      const dataslist = this.showIndustrySubclass.filter((item) => list.includes(item.id.toString()));
      // 通过子类数据中父类id去匹配父类id1数组
      const arrDaids = dataslist.filter((item) => this.form.industryCategoryJsonId.includes(item.parentId.toString())).map((res) => res.id + '');
      // this.form.industryCategoryJsonId
      this.form.industrySubclassJsonId = arrDaids; // 经营行业（行业小类）ID
      this.industrySubCategoryChange(arrDaids);
    },
    // 大类改变事件
    industryCategoryChange(val) {
      // 获取选择的大类id及值
      const list = this.industryClass;
      const typeIdArr = val; // 选择的大类id
      // 多选
      const res = [];
      for (const obj of list) {
        if (typeIdArr.includes(obj.id) || typeIdArr.includes(obj.id.toString())) {
          res.push(obj.industryCategoryName);
        }
      }
      console.log(res, typeIdArr);
      this.form.industryCategoryJsonId = typeIdArr; // 行业分类（行业大类）ID
      this.form.industryCategoryJsonName = res; // 行业分类（行业大类）名称
      // 获取满足条件的子类数据
      this.getShowSubClass(val);
    },
    newArrFn(arr) {
      // .new Set方法，返回是一个类数组，需要结合 ...运算符，转成真实数组
      return [...new Set(arr)];
    },
    // 小类改变事件
    industrySubCategoryChange(val) {
      const allSubClassList = this.industrySubclass;
      const subTypeIdArr = val;
      const res = [];
      for (const obj of allSubClassList) {
        if (subTypeIdArr.includes(obj.id) || subTypeIdArr.includes(obj.id.toString())) {
          res.push(obj.industryCategoryName);
        }
      }

      this.form.industrySubclassJsonId = subTypeIdArr; // 经营行业（行业小类）ID
      this.form.industrySubclassJsonName = res; // 经营行业（行业小类）名称
    },

    // int验证
    intValidate(fieldName) {
      const val = this.form[fieldName];
      const reg = /^[0-9]{1,6}$/;
      if (reg.test(val)) {
        if (!isNaN(val)) {
          this.form[fieldName] = parseInt(val);
        }
      } else {
        this.form[fieldName] = '';
      }
    },
    // 商铺性质为新房时，经营状态为空置中，现经营为空，不显示
    shopNatureChange(e) {
      if (e === '3') {
        // 1二手商铺 2招商项目 3新房
        this.form.operatingStatusId = '1'; // 经营状态 1空置中 2营业中
        // 现经营
        // this.getIndustryCategoryList(this.form.industryCategoryId)
      }
    },
    // 计算单价
    getUnitPrice() {
      if (this.form.salePrice && this.form.grossFloorArea) {
        // 单价
        const res = (this.form.salePrice / this.form.grossFloorArea).toFixed(2);
        console.log(res);
        if (!isNaN(res)) {
          this.form.unitPrice = res;
        } else {
          this.form.unitPrice = '';
        }
      }
    },
    // 不动产发票金额操作
    invoiceChange(e) {
      this.invoiceChecked = !e.target.checked;
    },
    // 抵押金额操作
    mortgageChange(e) {
      this.mortgageChecked = !e.target.checked;
    },
    // 行业分类
    getIndustryCategory(type) {
      industryCategoryList({ industryCategoryType: type }).then((res) => {
        if (res.code === 200) {
          this.industryCategory = res.data;
        }
      });
    },

    getState() {
      this.form.alloweCateringTypeId = undefined;
    },
    // 获取房源的详细信息
    getHouseDetails() {
      houseInfoSale(this.houseId).then((res) => {
        if (res.code === 200) {
          this.getlist(res.data.industryCategoryId);
          this.form = res.data;
          console.log(this.form, 'this.form ');
          this.form.lessorInfoVoList = this.form.lessorInfoVoList || [
            {
              //	业主信息		true
              id: undefined, //	id，新增时不传，修改时必传		true
              lessorsName: undefined, //	业主姓名		true
              lessorsPhone: undefined, //	业主电话
              lessorsType: '1', //	业主类型
              phoneTips: '', // 电话输入错误提示
              rentSaleType: '2' // 售房
            }
          ];
          this.form.lessorInfoBoList = this.form.lessorInfoVoList;
          const shopAncillary_ = this.form.shopAncillary;
          this.form.shopAncillaryArr = shopAncillary_ ? shopAncillary_.split(',') : null;
          const pleLIst = this.form.paymentMethod.split('F');
          this.paymentMethod1 = pleLIst[0].replace('Y', '');
          this.paymentMethod2 = pleLIst[1];
          const tagsIdStrArr = this.form.tagsIdArray ? this.form.tagsIdArray.split(',') : null;
          if (tagsIdStrArr != null && tagsIdStrArr.length > 0) {
            this.form.tagsIdArr = tagsIdStrArr.map((value) => {
              return parseInt(value);
            });
          } else {
            this.form.tagsIdArr = [];
          }
          if (this.form.districtId) {
            // 商圈列表
            // this.getBusinessDistrictList({ businessDistrictName: '', districtId: this.form.districtId }, null)
            // 街道列表
            // this.getStreetList(null)
          }
          // 行业大类名称
          const industryCategoryJsonName = this.form.industryCategoryJsonName;
          this.form.industryCategoryJsonName = industryCategoryJsonName ? JSON.parse(industryCategoryJsonName) : [];
          // 行业大类ID
          const industryCategoryJsonId = this.form.industryCategoryJsonId;
          this.form.industryCategoryJsonId = industryCategoryJsonId ? JSON.parse(industryCategoryJsonId) : [];
          // 行业小类名称
          const industrySubclassJsonName = this.form.industrySubclassJsonName;
          this.form.industrySubclassJsonName = industrySubclassJsonName ? JSON.parse(industrySubclassJsonName) : [];
          // 行业小类ID
          const industrySubclassJsonId = this.form.industrySubclassJsonId;
          this.form.industrySubclassJsonId = industrySubclassJsonId ? JSON.parse(industrySubclassJsonId) : [];

          this.form.consumeAncillaryIds = JSON.parse(this.form.consumeAncillaryIds) || [];
          this.form.consumeAncillaryIdArr = JSON.parse(JSON.stringify(this.form.consumeAncillaryIds));
          this.getStreetList();
          this.initIndustryCategory();
          // this.getlist(res.data.industryCategoryId)
          this.$forceUpdate();
        }
      });
    },
    // 回显行业分类小类
    getlist(id) {
      const parmars = {
        parentId: id,
        industryCategoryType: 2
      };
      industryCategoryList(parmars).then((res) => {
        const { code, data } = res;
        this.loading = false;
        if (code === 200) {
          this.industrySubclass = data;
        }
      });
    },

    shopAncillaryChange(val) {
      if (!val) return;
      this.form.shopAncillaryArr = val;
      const IDLIST = [];
      const LIST = this.shopAncillaryOpts.filter((item) => {
        return val.indexOf(item.dictLabel) > -1;
      });
      for (const obj of LIST) {
        IDLIST.push(obj.dictValue);
      }
      this.form.shopAncillary = val.join(',');
      this.form.shopAncillaryIds = IDLIST;
      this.$forceUpdate();
    },
    consumeAncillaryChange(val) {
      if (!val) return;
      if (val.length > 4) {
        val = val.splice(0, 4);
        this.$message.error('消费配套最多只能选4个，请慎重选择');
      }
      this.form.consumeAncillaryIdArr = val;
      this.form.consumeAncillaryIds = val;
      const NAMELIST = [];
      const LIST = this.consumeAncillaryOpts.filter((item) => {
        return val.indexOf(item.dictValue) > -1;
      });
      for (const obj of LIST) {
        NAMELIST.push(obj.dictLabel);
      }
      this.form.consumeAncillary = NAMELIST.join(',');
      this.$forceUpdate();
    },
    tagChange(val) {
      console.log(val);
      this.form.tagsIdArr = val;
      if (!val) {
        return;
      }
      this.form.tagsIdArray = val.join(',');
      const tIdArr = this.form.tagsIdArray.split(',');
      const tagsNameArr = [];
      for (const item of this.CusListData) {
        for (const tId of tIdArr) {
          if (item.id === tId) {
            tagsNameArr.push(item.tagName);
          }
        }
      }
      this.form.tagsContentArray = tagsNameArr.join(',');
      this.form = { ...this.form };
      this.$forceUpdate();
    },
    // // 获取商圈
    // getBusDistrict (data) {
    //   houseApi.businessDistrict(data).then((res) => {
    //     if (res.code === 200) {
    //       this.businessDistrict = res.data
    //       this.getStreetMethod()
    //     }
    //   })
    // },
    // 新增商圈
    getaddBusinessDistrict() {
      const params = {
        businessDistrictName: '吾悦广场33',
        businessDistrictScope: '奶牛广场33',
        districtId: 3,
        id: 3,
        isPrimaryBusinessDistrict: '是'
      };
      houseApi.addBusinessDistrict(params).then((res) => {});
    },
    // 获取街道
    // getStreetMethod () {
    //   // 重置门牌号、附号信息
    //   this.resetHouseNumber()
    //   const params = {
    //     businessDistrictId: this.form.businessDistrictId,
    //     streetFullName: '',
    //     streetShortName: ''
    //   }
    //   houseApi.GetStreetList(params).then((res) => {
    //     if (res.code === 200) {
    //       this.StreetData = res.data
    //     }
    //   })
    // },
    // 重置附号信息
    resetHouseNumberDeputy() {
      this.form.houseNumberDeputy = undefined;
      this.form.houseNumberDeputyId = undefined;
    },

    // // 获取街道id StreetMethod
    // StreetMethod (val) {
    //   this.form.communityName = undefined
    //   this.form.houseFloor = undefined
    //   this.form.houseNumber = undefined
    //   this.form.houseNumberDeputy = undefined
    //   const newStreet = this.StreetData.find((item) => {
    //     return item.streetFullName === val
    //   })
    //   this.form.streetId = newStreet.id
    //   this.getDoorNumData(this.form.streetId)
    //   this.getSearchHouseMsg()
    // },
    // 根据街道id获取门牌号
    getDoorNumData(val) {
      this.doorNumData = [];
      this.getStreetNumbers(val);
    },
    // 根据门牌号id获取附号信息
    houseNumberMethod(val) {
      console.log(val, 'dsfs');
      this.resetHouseNumberDeputy();
      // 获取门牌号id
      // this.houseNumberChange(val)
      for (const item of this.doorNumData) {
        if (item.houseNumber === val) {
          this.attachedNumberData = item.attachedList;
          this.form.houseNumberId = item.attachedList[0].id;
          // this.form.houseNumberDeputyId = item.attachedList[0].id
          // this.form.houseNumberDeputy = item.attachedList[0].attachedNumber
          // 执行附号改变事件
          this.houseNumberDeputyChange(item.attachedList[0].attachedNumber, 'no');
        }
      }
      this.getCommunityInfoByQuery(val);
    },
    // 根据门牌号获取小区信息（有变动才触发）
    getCommunityInfoByQuery(houseNumber) {
      const query = {
        communityFullName: undefined, // 小区全称	query	false
        communityShortName: undefined, //	小区简称	query	false
        houseNumber: houseNumber, //	门牌号	query	false
        streetId: this.form.streetId //	街道ID
      };
      houseApi.getCommunityByQuery(query).then((response) => {
        this.community = response.data;
        const community_ = this.community;
        if (community_ != null) {
          this.form.propertyFee = community_.propertyFee; // 物业费
          this.form.waterFee = community_.waterFee; //	水费
          this.form.electricityFee = community_.electricityFee; //	电费
          this.form.gasFee = community_.gasFee; //	气费
          this.form.communityName = community_.communityFullName; //	小区全称
          this.form.communityId = community_.id; //	小区id
          this.form.areaId = community_.areaId; //	行政区ID
        } else {
          this.form.propertyFee = undefined; // 物业费
          this.form.waterFee = undefined; //	水费
          this.form.electricityFee = undefined; //	电费
          this.form.gasFee = undefined; //	气费
          this.form.communityName = undefined; //	小区全称
          this.form.communityId = undefined; //	小区id
          this.form.areaId = undefined; //	行政区ID
        }
      });
    },
    // 门牌附号
    houseNumberDeputyChange(val, validteExist) {
      const newNum = this.doorNumData.find((item) => {
        return item.houseNumber === this.form.houseNumber;
      });
      const attachedList_ = newNum.attachedList;
      const newDeputyNum = attachedList_.find((item) => {
        return item.attachedNumber === val;
      });
      if (newDeputyNum) {
        this.form.houseNumberDeputyId = newDeputyNum.id;
      } else {
        this.form.houseNumberDeputyId = undefined;
      }

      if (validteExist !== 'no') {
        // 查询房源是否存在
        this.getSearchHouseMsg();
      }
    },

    getStreetNumbers(streetId) {
      if (!streetId) {
        return;
      }
      houseApi.getStreet(streetId).then((response) => {
        this.dataInfo = response.data;
        const volist = this.dataInfo.attachedInfoVoList;
        this.houseNumberArr = volist;
        this.dataInfo.attachedInfoBoList = volist;

        const houseNumberArr = [];
        const houseNumberArr_ = [];
        for (const vo of volist) {
          houseNumberArr_.push(vo.houseNumber);
        }
        var set = new Set(houseNumberArr_);
        // 将set转换为数组
        const [...newHouseNumberArr_] = set;

        const newHouseNumberArr = [];
        for (const obj of newHouseNumberArr_) {
          newHouseNumberArr.push({
            houseNumber: obj,
            attachedList: []
          });
        }

        const _arr = [];
        for (const h of newHouseNumberArr) {
          let attArr = [];
          for (const vo of volist) {
            houseNumberArr.push(vo.houseNumber);
            if (h.houseNumber === vo.houseNumber) {
              attArr.push(vo);
            }
          }
          h.attachedList = attArr;
          attArr = [];
          _arr.push(h);
        }
        this.doorNumData = _arr;
        this.initHouseNumberDeputyMethod(this.form.houseNumber);
      });
    },

    // 添加业主
    addClick() {
      if (this.form.lessorInfoBoList && this.form.lessorInfoBoList.length >= 4) {
        this.$message.error('最多只能添加4位联系人');
      } else {
        const obj = {
          lessorsName: undefined, //	业主姓名		true
          lessorsPhone: undefined, //	业主电话
          lessorsType: undefined //	业主类型
        };
        this.form.lessorInfoBoList.push(obj);
        this.$forceUpdate();
      }
    },
    getLessorsType() {
      const typeArr = []; // 两位业主信息
      const agentArr = []; // 代理人
      const boList = JSON.parse(JSON.stringify(this.form.lessorInfoBoList));
      console.log(boList, 'boList');
      boList.forEach((item) => {
        if (item.lessorsType === '1') {
          typeArr.push(item.lessorsType);
        }
        if (item.lessorsType === '4') {
          agentArr.push(item.lessorsType);
        }
      });
      this.agentArr = agentArr;
      this.typeArr = typeArr;
      this.$forceUpdate();
      if (typeArr.length >= 4) {
        this.$message.error('最多添加三位位业主');
        return;
      }
      if (agentArr.length >= 2) {
        this.$message.error('最多添加一位代理人');
      }
    },
    // 判断电话是否重复
    getLessorsPhone() {
      // 判断电话是否重复
      const lessorsPhoneArr = [];
      this.form.lessorInfoBoList.forEach((item) => {
        if (item.lessorsPhone) {
          lessorsPhoneArr.push(item.lessorsPhone);
        }
      });
      this.lessorsPhoneArr = lessorsPhoneArr;
      for (var i = 0; i < lessorsPhoneArr.length; i++) {
        if (lessorsPhoneArr.indexOf(lessorsPhoneArr[i]) !== i) {
          this.$message.error('联系人电话不能重复');
          return;
        }
      }
    },
    // 动态绑定电话号码正则
    validateLessorsPhone(value, index) {
      // 判断电话是否错误
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      this.form.lessorInfoBoList.forEach((item, i) => {
        if (index === i) {
          if (!value || !reg.test(value)) {
            item.phoneTips = '请输入正确的电话号码';
          } else {
            item.phoneTips = '';
          }
        }
      });
    },
    // 删除业主
    delClick(index) {
      if (this.form.lessorInfoBoList.length === 1) {
        this.$message.warning('最少要添加一位联系人');
      } else {
        this.form.lessorInfoBoList.splice(index, 1);
        this.$forceUpdate();
      }
    },
    // 商铺change事件
    shopChange(val) {},
    onSubmit() {
      // const arr = []
      const transArr = [];
      const typeArr = [];
      this.form.lessorInfoBoList.forEach((item) => {
        if (item.lessorsType === '4') {
          // 代理人
          transArr.push(item.lessorsType);
        }
        if (item.lessorsType === '1') {
          // 业主
          typeArr.push(item.lessorsType);
        }
        // if (item.phoneTips) {
        //   this.$message.error('请输入正确的联系人电话')
        //   return
        // }
        if (!item.lessorsName || !item.lessorsPhone) {
          this.$message.error('请输入联系人信息');
          return;
        }
        console.log('不要删这个log');
        //  if (item.lessorsType === '1') {
        //   arr.push(item.lessorsType)
        // }
      });
      this.isphone = false;
      this.form.lessorInfoBoList.find((item) => {
        if (item.phoneTips) {
          this.isphone = true;
        }
      });
      if (this.isphone) {
        this.$message.error('请输入正确的联系电话');
        return;
      }
      for (var i = 0; i < this.lessorsPhoneArr.length; i++) {
        if (this.lessorsPhoneArr.indexOf(this.lessorsPhoneArr[i]) !== i) {
          this.$message.error('联系人电话不能重复');
          return;
        }
      }
      if ((typeArr && typeArr.length === 0 && transArr && transArr.length === 0) || (!typeArr && !transArr)) {
        this.$message.error('至少填写一位业主或代理人信息');
        return;
      }
      if (typeArr.length >= 4) {
        this.$message.error('最多添加三位业主信息');
        return;
      }
      if (transArr.length >= 2) {
        this.$message.error('最多添加一位代理人');
        return;
      }

      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.refer();
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },

    buttonItemLayout() {
      const { layout } = this.form;
      return layout === 'horizontal'
        ? {
            wrapperCol: { span: 14, offset: 4 }
          }
        : {};
    },
    // // 获取区域ID
    // regionChange (val) {
    //   this.form.businessDistrictName = ''
    //   this.form.streetName = ''
    //   this.form.communityName = undefined
    //   this.form.houseFloor = undefined
    //   const regionChild = this.region.find((item) => {
    //     return item.districtFullName === val
    //   })
    //   this.form.districtId = regionChild.id
    //   this.getBusDistrict({ businessDistrictName: '', districtId: regionChild.id })
    //   this.getSearchHouseMsg()
    // },
    goList() {
      this.$store.dispatch('tagsView/delCachedView', 'HousesSellAdd');
      // this.$route.meta.position = {x:0,y:0}
      this.$router.push('/house/HousesListSell');
    },
    // 新增房源
    addhouse() {
      this.form.channelResource = '1';
      addHouseInfoSale({ ...this.form }).then((res) => {
        if (res.code === 200) {
          this.$message.success('新增房源信息成功');
          this.saveType = true;
          this.goList();
        }
      });
    },
    // 编辑房源
    edithouse() {
      this.form.channelResource = '1';
      editHouseInfoSale({ ...this.form }).then((res) => {
        if (res.code === 200) {
          this.$message.success('修改房源信息成功');
          this.saveType = true;
          this.goList();
        }
      });
    },
    // 查询房源自定义标签列表
    getCusTag() {
      houseApi.GethouseCustomTag({ tagName: '', rentSaleType: this.rentSaleType }).then((res) => {
        if (res.code === 200) {
          this.CusListData = res.data;
        }
      });
    },
    // 自定义标签change事件
    cusLabel(val) {
      this.addCusData = val;
    },
    // 租金
    rent() {
      this.form.rentFeeCentiare = parseFloat(this.form.rentFee / this.form.grossFloorArea).toFixed(2);
      if (this.form.grossFloorArea) {
        this.form.rentFeeCentiare = parseFloat(this.form.rentFee / this.form.grossFloorArea).toFixed(2);
      }
    },

    // 提交
    refer() {
      this.form.paymentMethod = 'Y' + this.paymentMethod1 + 'F' + this.paymentMethod2;
      // 售房如果是空置中  没有租金到期时间和付款方式
      if (this.form.operatingStatusId === '1') {
        this.form.rentFee = undefined;
        this.form.expireTime = undefined;
        this.form.paymentMethod = '';
      }
      if (this.form.operatingStatusId === '1') {
        this.form.rentFee = undefined;
        this.form.expireTime = undefined;
      }
      if (this.addoredit === 0) {
        let isSave;
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            isSave = true;
          } else {
            isSave = false;
          }
        });
        if (this.form.isCatering === 'Y' && !this.form.alloweCateringTypeId) {
          this.$message.warning('请选择餐饮状态');
          return;
        }
        if (!isSave) {
          this.$message.warning('请填写完整');
          return;
        }

        //  处理是否临街数据（0为true,1为false）
        if (this.form.isFrontage === 0) {
          this.form.isFrontage = 'Y';
        } else {
          this.form.isFrontage = 'N';
        }
        this.isBanbetsu = true;
      } else {
        this.edithouse();
      }
    },
    addChange(a) {
      a.forEach((item) => {
        this.form[item] = 'Y';
      });
    },
    // 查询房源是否存在
    getSearchHouseMsg() {
      const { districtName, businessDistrictName, streetName } = this.form;
      const { districtId, businessDistrictId, streetId, houseNumber, houseNumberDeputy } = this.form;
      if (districtName && businessDistrictName && streetName && houseNumber && houseNumberDeputy) {
        const parmars = {};
        parmars.districtId = districtId;
        parmars.businessDistrictId = businessDistrictId;
        parmars.streetId = streetId;
        parmars.houseNumber = houseNumber;
        parmars.houseNumberDeputy = houseNumberDeputy;
        if (this.houseId) {
          parmars.id = this.houseId;
        }
        searchHouseInfoSale(parmars).then((res) => {
          if (res.code === 200) {
            if (res.data.isExists) {
              // isExists为true 房源信息存在  不能再次提交
              this.isExists = res.data.isExists;
              this.detailsId = res.data.houseInfoId;
              this.houseCode = res.data?.houseCode || undefined;
              this.$message.warning('该房源信息已经存在');
              this.visibleDetials = true;
            } else {
              this.isExists = res.data.isExists;
              this.$message.success('新房源!');
            }
          }
        });
      }
    },
    // 存在房源跳转
    handleDetails() {
      this.visibleDetials = false;
      this.$router.push({
        path: '/houses/detail/sell',
        query: {
          id: this.detailsId,
          formTitle: '售房详情'
        }
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  },
  // 监听子类 联动父类
  watch: {
    'form.houseFloorType': {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.form.houseFloor = '';
        }
      }
    },
    'form.industrySubclassJsonId': {
      handler: function (newVal, oldVal) {
        const data = this.showIndustrySubclass.filter((item) => newVal.includes(item.id + ''));
        const fatherChilds = this.newArrFn(data.map((item) => item.parentId + ''));
        const obj = {};
        fatherChilds.forEach((item) => {
          const arr = [];
          data.forEach((el) => {
            if (item == el.parentId + '') {
              arr.push(el.id);
              obj[item] = arr.join(',');
            }
          });
        });
        this.form.industryCategoryJsonKeyValueId = obj;
        if (this.isWatch) {
          this.form.industryCategoryJsonId = fatherChilds;
          console.log(fatherChilds, 'fatherChilds');
        } else {
          this.isWatch = true;
        }
      }
    },
    deep: true
  }
};
</script>

<style>
.ant-checkbox-wrapper + .ant-checkbox-wrapper {
  margin-left: 0;
}
</style>
<style lang="less" scoped>
.w120 {
  width: 120px;
}
.ml20 {
  margin-left: 20px;
}
.ml10 {
  margin-left: 10px;
}
.add {
  width: 100%;
  // height: 400px;
  // background-color: rgb(107, 3, 3);
  background-color: white;
  labelCol {
    width: 150px;
  }
  .add-center {
    width: 95%;
    margin: 0 auto;

    header {
      height: 80px;
      display: flex;
      align-items: center;

      & > p {
        margin-bottom: 0;
        font-size: 26px;
        font-weight: bold;
        color: black;
      }
      & > img {
        // flex-shrink: 1;
        width: 20px;
        height: 20px;
        margin-left: 6px;
        margin-top: 3px;
      }
    }
    aside {
      .main {
        width: 94%;
        // height: 100px;
        // background-color: aqua;
        margin: 0 auto;
        background-color: white;

        & > .main-form {
          width: 100%;
          margin: 0px auto 0;
          /* margin: 30px auto 0; */
          /deep/ p {
            font-size: 24px;

            color: black;
          }
          /deep/ .ant-col-4 {
            width: 21.666667%;
            text-align: left;
          }
          /deep/ .ant-col-10 {
            width: 29.666667%;
          }
          /deep/ .ant-form-item {
            display: flex;
            flex-direction: column;
          }
          /deep/ .addInfor {
            margin-top: 42px;
          }
          .hr {
            width: 100%;
            height: 1px;
            border: 1px solid #f2f6fc;
            margin-top: 10px;
            margin-bottom: 20px;
          }
          /deep/ .ant-col-12 {
            width: 25%;
          }
          #basicStore {
            list-style: none;
            display: flex;
            justify-content: space-between;
            width: 64%;
            margin-left: -41px;
          }
          #current {
            list-style: none;
            display: flex;
            width: 65.4%;
            justify-content: space-between;
            margin-left: -41px;
            /deep/li {
              width: 200px;
            }
          }
          .bacisInfo {
            width: 80%;
            list-style: none;
            display: flex;
            justify-content: space-between;
            margin-left: -41px;
          }
          .checkrow {
            /deep/ ul {
              list-style: none;
              li {
                label {
                  margin-right: 10px;
                }
                .input_val {
                  width: 60px;
                  border: 1px solid #d9d9d9;
                  outline: none;
                  height: 16px;
                  margin-right: 20px;
                }
              }
            }
          }
          /deep/ #priceInfor {
            width: 65%;
            display: flex;
            list-style: none;
            justify-content: space-between;
            align-items: center;
            margin-left: -41px;

            & > li {
              margin-right: 10px;
            }
          }
          /deep/ #paymethod {
            width: 68%;
            display: flex;
            list-style: none;
            justify-content: space-between;
            align-items: center;
            margin-left: -41px;
          }
          /deep/ #commfee {
            list-style: none;
            display: flex;
            justify-content: space-between;
            width: 37%;
            margin-left: -41px;
          }
          /deep/ .submit {
            width: 80px;
            height: 35px;
            border-radius: 5px;
            font-size: 15px;
            text-align: center;
            line-height: 35px;
            background-color: var(--ThemeColor);
          }
        }
      }
    }
  }
}
.search-btn {
  width: 60px;
  margin-left: 20px;
}
.submit-btns {
  padding-top: 30px;
  /deep/.ant-col-18 {
    width: 100% !important;
  }
}
.inline-box {
  /deep/.ant-form-item-children {
    display: flex;
  }
}
</style>
